var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120.365,
    height: 32,
    viewBox: "0 0 120.365 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.141,
    cy: 0.148,
    r: 0.535,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#353546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#353546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15151d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.322,
    y1: -0.027,
    x2: 1,
    y2: 0.686,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#f8af0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#ff8344"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1596b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16289",
    "data-name": "Group 16289",
    transform: "translate(-19.635 -106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14140",
    "data-name": "Group 14140",
    transform: "translate(-6 6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4192",
    "data-name": "Rectangle 4192",
    width: 120,
    height: 32,
    transform: "translate(26 100)",
    opacity: 0,
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16289-2",
    "data-name": "Group 16289",
    transform: "translate(-1896.836 3030.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    transform: "translate(1922.836 -2927.135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18362",
    "data-name": "Path 18362",
    d: "M19.358,22.879a4.557,4.557,0,0,0-.4-1.3,4.373,4.373,0,0,0-1-1.4,6.891,6.891,0,0,0-1.441-1.024,10.812,10.812,0,0,0-1.719-.735l-.391-.126L10.49,22.733q.3.061.591.114a6.479,6.479,0,0,1,1.137.316,3.908,3.908,0,0,1,.5.211,3.687,3.687,0,0,1,.5.3,1.693,1.693,0,0,1,.4.395.866.866,0,0,1,.159.514,1.413,1.413,0,0,1-.278.935,1.656,1.656,0,0,1-.7.487,3.429,3.429,0,0,1-.939.2q-.516.039-.965.039c-.64,0-2.67-.178-3.269-.268.007,0-3.663,4.214-3.662,4.214a40.494,40.494,0,0,0,6.218.735,18.637,18.637,0,0,0,3.332-.3,9.441,9.441,0,0,0,2.988-1.05,5.672,5.672,0,0,0,2.962-5.317,9.225,9.225,0,0,0-.106-1.378Z",
    transform: "translate(-1.797 -7.505)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18363",
    "data-name": "Path 18363",
    d: "M7.095,3.663a10.568,10.568,0,0,0-2.367.632A7.3,7.3,0,0,0,2.679,5.533a6,6,0,0,0-1.507,2A5.733,5.733,0,0,0,.735,8.813a6.248,6.248,0,0,0-.146,1.33,5.968,5.968,0,0,0,.674,3.042,5.157,5.157,0,0,0,1.8,1.825l.046-.06L6.535,10.5a.894.894,0,0,1-.1-.13,1.2,1.2,0,0,1-.159-.63,1.257,1.257,0,0,1,.238-.8,1.511,1.511,0,0,1,.608-.459,2.654,2.654,0,0,1,.806-.2q.169-.015.331-.024L8.3,8.2l3.513-4.569c-2.569.011-4.637.023-4.72.035Z",
    transform: "translate(-0.455 -1.675)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18364",
    "data-name": "Path 18364",
    d: "M40.923,24.23H34.349l-3.582-5.343H30.5L26.918,24.23H23.534c.1-.1.2-.2.3-.3a7.609,7.609,0,0,0,1.954-7.354q-.047-.167-.1-.33l1.658-2.489L23.689,8.287H17.955l2.238-4.675h.369L22.471,3.6h4.662L30.5,8.653h.268L34.135,3.6h6.575L33.921,13.756l7,10.473Z",
    transform: "translate(-7.361 -1.665)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18365",
    "data-name": "Path 18365",
    d: "M29.884,3.591H25.453l4.424-.018Z",
    transform: "translate(-10.342 -1.653)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18366",
    "data-name": "Path 18366",
    d: "M24.191,3.6l-1.909.008,0-.008Z",
    transform: "translate(-9.08 -1.665)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18367",
    "data-name": "Path 18367",
    d: "M8.717,10.813l4.237-.2-.38.431L8.632,15.523.365,24.91,7.293,13.272l-3.968.618.008-.01L6.743,9.443,8.66,6.949l3.546-4.613C13.1,1.177,13.689.409,13.708.385l-.933,1.949L10.538,7.008,8.717,10.813Z",
    transform: "translate(-0.365 -0.385)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_19255",
    "data-name": "Path 19255",
    d: "M12.894-16.562a1.039,1.039,0,0,1-.357.434.9.9,0,0,1-.483.126,1.228,1.228,0,0,1-.63-.217q-.35-.217-.826-.483a6.745,6.745,0,0,0-1.113-.483A4.678,4.678,0,0,0,7.98-17.4a4.424,4.424,0,0,0-1.365.189,2.89,2.89,0,0,0-.98.525,2.1,2.1,0,0,0-.6.8,2.643,2.643,0,0,0-.2,1.029,1.789,1.789,0,0,0,.4,1.19,3.332,3.332,0,0,0,1.057.812,9.81,9.81,0,0,0,1.5.6q.84.266,1.715.567a16.516,16.516,0,0,1,1.715.7,5.943,5.943,0,0,1,1.5,1.008,4.568,4.568,0,0,1,1.057,1.491,5.178,5.178,0,0,1,.4,2.142,6.979,6.979,0,0,1-.469,2.569,5.927,5.927,0,0,1-1.372,2.086,6.462,6.462,0,0,1-2.2,1.4A8.118,8.118,0,0,1,7.154.224,9.615,9.615,0,0,1,5.25.035,10.023,10.023,0,0,1,3.451-.5a9.393,9.393,0,0,1-1.61-.84A7.923,7.923,0,0,1,.5-2.436L1.6-4.242a1.393,1.393,0,0,1,.371-.329A.906.906,0,0,1,2.45-4.7a1.336,1.336,0,0,1,.756.287q.406.287.959.637a7.359,7.359,0,0,0,1.3.637,5.033,5.033,0,0,0,1.8.287,3.693,3.693,0,0,0,2.492-.763A2.74,2.74,0,0,0,10.64-5.81a2.034,2.034,0,0,0-.4-1.3,3.221,3.221,0,0,0-1.057-.847,7.892,7.892,0,0,0-1.5-.581q-.84-.238-1.708-.518A14.729,14.729,0,0,1,4.27-9.73a5.533,5.533,0,0,1-1.5-1.022,4.65,4.65,0,0,1-1.057-1.575,6,6,0,0,1-.4-2.331,5.518,5.518,0,0,1,.441-2.156,5.52,5.52,0,0,1,1.288-1.862,6.358,6.358,0,0,1,2.079-1.3,7.568,7.568,0,0,1,2.814-.49,9.443,9.443,0,0,1,3.3.56,7.459,7.459,0,0,1,2.576,1.568ZM21.588.224a3.778,3.778,0,0,1-2.87-1.057A4.057,4.057,0,0,1,17.71-3.752v-8.022H16.254a.7.7,0,0,1-.483-.182.7.7,0,0,1-.2-.546v-1.372l2.31-.378.728-3.92a.693.693,0,0,1,.259-.434.821.821,0,0,1,.511-.154h1.792v4.522h3.78v2.464h-3.78V-3.99A1.526,1.526,0,0,0,21.5-2.94a1.14,1.14,0,0,0,.9.378,1.627,1.627,0,0,0,.539-.077,2.967,2.967,0,0,0,.378-.161q.161-.084.287-.161a.48.48,0,0,1,.252-.077.4.4,0,0,1,.252.077,1.168,1.168,0,0,1,.21.231l1.036,1.68A5.235,5.235,0,0,1,23.618-.1,6.462,6.462,0,0,1,21.588.224ZM27.706,0V-14.364h2.03a1.088,1.088,0,0,1,.742.2,1.127,1.127,0,0,1,.28.672l.21,1.736a6.824,6.824,0,0,1,1.806-2.1,3.8,3.8,0,0,1,2.324-.77,3,3,0,0,1,1.764.49l-.448,2.59a.535.535,0,0,1-.182.357.616.616,0,0,1-.378.1,2.358,2.358,0,0,1-.574-.1,3.842,3.842,0,0,0-.966-.1,2.933,2.933,0,0,0-1.848.6,4.581,4.581,0,0,0-1.3,1.743V0ZM49.994,0H48.44a1.674,1.674,0,0,1-.77-.147.946.946,0,0,1-.42-.595l-.308-1.022A11.86,11.86,0,0,1,45.871-.9a6.5,6.5,0,0,1-1.085.623A5.534,5.534,0,0,1,43.6.1a7.159,7.159,0,0,1-1.4.126,5.515,5.515,0,0,1-1.68-.245,3.622,3.622,0,0,1-1.323-.735,3.338,3.338,0,0,1-.861-1.218,4.321,4.321,0,0,1-.308-1.694,3.342,3.342,0,0,1,.427-1.6A4.018,4.018,0,0,1,39.872-6.7a9.087,9.087,0,0,1,2.646-1.057,18.7,18.7,0,0,1,4.1-.476v-.84a3.169,3.169,0,0,0-.609-2.135A2.232,2.232,0,0,0,44.24-11.9a4.286,4.286,0,0,0-1.4.2,5.416,5.416,0,0,0-.973.441q-.413.245-.763.441a1.549,1.549,0,0,1-.77.2,1,1,0,0,1-.6-.182,1.433,1.433,0,0,1-.406-.448l-.63-1.106a8.541,8.541,0,0,1,5.978-2.268,5.776,5.776,0,0,1,2.247.413,4.776,4.776,0,0,1,1.673,1.148,4.913,4.913,0,0,1,1.043,1.757,6.752,6.752,0,0,1,.357,2.24Zm-6.72-2.156a4.588,4.588,0,0,0,.98-.1,3.713,3.713,0,0,0,.847-.294,4.5,4.5,0,0,0,.77-.483,6.991,6.991,0,0,0,.749-.679V-6.132a18.935,18.935,0,0,0-2.527.259,6.716,6.716,0,0,0-1.631.483,2.1,2.1,0,0,0-.875.686,1.518,1.518,0,0,0-.259.854,1.5,1.5,0,0,0,.539,1.3A2.336,2.336,0,0,0,43.274-2.156ZM58.114.224a3.778,3.778,0,0,1-2.87-1.057,4.057,4.057,0,0,1-1.008-2.919v-8.022H52.78a.7.7,0,0,1-.483-.182.7.7,0,0,1-.2-.546v-1.372l2.31-.378.728-3.92a.693.693,0,0,1,.259-.434.821.821,0,0,1,.511-.154h1.792v4.522h3.78v2.464h-3.78V-3.99a1.526,1.526,0,0,0,.336,1.05,1.14,1.14,0,0,0,.9.378,1.627,1.627,0,0,0,.539-.077,2.967,2.967,0,0,0,.378-.161q.161-.084.287-.161a.48.48,0,0,1,.252-.077.4.4,0,0,1,.252.077,1.168,1.168,0,0,1,.21.231L61.88-1.05A5.235,5.235,0,0,1,60.144-.1,6.462,6.462,0,0,1,58.114.224Zm11.172-10.64-6.454-9.828h3.752a1.15,1.15,0,0,1,.567.1.946.946,0,0,1,.315.343l4.606,7.434q.07-.182.154-.357a3.916,3.916,0,0,1,.2-.357l4.214-6.65a.912.912,0,0,1,.8-.518h3.612L74.522-10.57,81.228,0H77.462a.909.909,0,0,1-.609-.2,1.85,1.85,0,0,1-.385-.448L71.778-8.4a2.768,2.768,0,0,1-.126.315q-.07.147-.14.273L67.018-.644A2.231,2.231,0,0,1,66.64-.2a.8.8,0,0,1-.56.2H62.552Z",
    transform: "translate(63.059 126.122)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.362c85e597d89b749c1c57027b10ba19.svg";
export { ForwardRef as ReactComponent };